import React from 'react';
import {connect} from "react-redux";
import {
  CABINET_LABELS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS
} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import {FormattedMessage} from "react-intl";
import cabinetWorkspace from "../../../../canvas/core/cabinet/cabinetWorkspace";
import SqftOptionsTallCabinetsList from "./commonParts/SqftOptionsTallCabinetsList";

const SqftNavigationTall = (props) => {
  const {activeFeature} = props;
  const {setSQFTActiveButton, setSQFTMenuOpened} = props;
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall

  const handleClose = () => {
    setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.move);
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
  }

  return (
    <div className={"content side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <div className="side-level2__title summary-main-title">
          <div className="summary-main-text">
            <FormattedMessage id="sqft.navigation.submenu.tallTitle"/>
          </div>
          <button className="button--close"
                  onClick={handleClose}
          />
        </div>
        {
          <SqftOptionsTallCabinetsList activeFeature={activeFeature}
                                   partId={CABINET_LABELS.bottom_cabinet}
                                   relatedItemsPartId={CABINET_LABELS.tall_cabinet_boxes}
                                   shouldSortByWidth={true}
                                   itemClickCallback={(feature, parentFeature) => {
                                     cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}
                                   }
          />
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationTall);
